import { Fields } from 'models/GrantableCampaign'
import orm from 'models/orm'
import { createSelector as createOrmSelector } from 'redux-orm'

export const selectGrantableCampaigns = createOrmSelector(
  orm,
  (state: any) => state.orm,
  (session: any): Fields[] => {
    return session.GrantableCampaign.all().toRefArray()
  }
)
